import { useSite } from '../../app/site';
import { cn } from '../../lib/cn';

/**
 * The medaka mark: a small fish in a rising current. Drawn inline so it inherits
 * the brand gradient and needs no network request. When a site icon is uploaded,
 * that file replaces this mark across the header, footer, and auth screens.
 */
export function LogoMark({ className }: { className?: string }) {
  const { settings } = useSite();
  const src = settings?.logoUrl || settings?.faviconUrl || null;
  if (src) {
    return <img src={src} alt="" className={cn('size-8 rounded-sm object-contain', className)} />;
  }
  return (
    <svg viewBox="0 0 32 32" className={cn('size-8', className)} role="img" aria-label="Medaka Games">
      <defs>
        <linearGradient id="medaka-mark" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="var(--primary)" />
          <stop offset="100%" stopColor="var(--violet)" />
        </linearGradient>
      </defs>
      <rect width="32" height="32" rx="9" fill="url(#medaka-mark)" />
      <path
        d="M9 16.5c2.6-3.4 6-5.1 10.2-5.1l-1.1 2.9 4.4-1.4c-.5 2.3-.5 4.3 0 6.1l-4.4-1.4 1.1 2.9c-4.2 0-7.6-1.7-10.2-4z"
        fill="var(--canvas)"
        fillOpacity="0.9"
      />
      <circle cx="17.2" cy="15.1" r="0.95" fill="url(#medaka-mark)" />
    </svg>
  );
}

export function Logo({ siteName, className }: { siteName: string; className?: string }) {
  return (
    <span className={cn('flex items-center gap-2.5', className)}>
      <LogoMark />
      <span className="hidden flex-col leading-none sm:flex">
        <span className="font-display text-sm font-semibold tracking-tight">{siteName}</span>
        <span className="text-2xs text-text-faint mt-0.5 tracking-[0.18em] uppercase">Reward</span>
      </span>
    </span>
  );
}
